import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useForm } from 'react-hook-form';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';

function SkillAdd() {
  const navigate = useNavigate();
  const { id } = useParams(); 
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isPrefilling, setIsPrefilling] = useState(false); 

  const token = localStorage.getItem('vedhvidhi-admin-token');

  useEffect(() => {
    
    if (id) {
      setIsPrefilling(true); 
      const fetchSkill = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BASEURL}/admin/skill/${id}`,
            {
              headers: {
                Authorization: token,
                'Content-Type': 'application/json',
              },
            }
          );
          const skillData = response?.data?.data;
          setValue('skillName', skillData?.skillName); 
        } catch (error) {
          toast.error('Failed to fetch Skill details');
        } finally {
          setIsPrefilling(false); 
        }
      };

      fetchSkill();
    }
  }, [id, setValue, token]);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      if (id) {
        
        await axios.patch(
          `${process.env.REACT_APP_BASEURL}/admin/skill/${id}`,
          { skillName: data.skillName },
          {
            headers: {
              Authorization: `${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        toast.success('Skill updated successfully!');
      } else {
        
        await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/skill`,
          { skillName: data.skillName },
          {
            headers: {
              Authorization: `${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        toast.success('Skill added successfully!');
      }
      navigate('/skill-list');
    } catch (error) {
      toast.error(id ? 'Failed to update Skill' : 'Skill is already added');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Toaster  />
      <div className="card-body">
        {isPrefilling ? ( 
          <p>Loading...</p>
        ) : (
          <form className="row g-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-sm-6">
              <label className="form-label">Skill Name</label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter Skill name (e.g. Face Reading)"
                {...register('skillName', { required: 'Skill Name is required' })}
              />
              {errors.skillName && <span className="text-danger">{errors.skillName.message}</span>}
            </div>

            {/* Submit Button */}
            <div className="col-12 mt-4">
              <button type="submit" className="btn btn-primary text-uppercase px-3" disabled={isLoading}>
                {isLoading ? (id ? 'Updating...' : 'Adding...') : (id ? 'Update' : 'Add')}
              </button>
              <button
                type="button"
                className="btn btn-secondary text-uppercase px-3 mx-2"
                onClick={() => navigate('/skill-list')}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
}

export default SkillAdd;
